import React, { useState } from "react";
import { toast } from "react-toastify";

const API_BASE = process.env.REACT_APP_API_URL;
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const loadingToastId = toast.loading("Sending reset link...", {
      position: "top-center",
    });

    try {
      const res = await fetch(`${API_BASE}/api/auth/request-reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const contentType = res.headers.get("content-type");

      if (res.ok && contentType && contentType.includes("application/json")) {
        const data = await res.json();
        toast.update(loadingToastId, {
          render: data.message || "Check your Gmail for reset instructions!",
          type: "success",
          isLoading: false,
          autoClose: 4000,
        });
      } else {
        const errorText = await res.text();
        console.error("Reset error response:", errorText);
        toast.update(loadingToastId, {
          render: "Failed to send reset link. Please try again.",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (err) {
      console.error("Request failed:", err);
      toast.update(loadingToastId, {
        render: "Something went wrong. Try again later.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-10">
      <form
        onSubmit={handleSubmit}
        className="bg-sky-800 p-8 rounded shadow-2xl shadow-black w-full max-w-sm"
      >
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-100">Forgot Password</h2>

        <input
          type="email"
          placeholder="Enter your email"
          className="w-full mb-4 p-2 border border-gray-300 rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button
          type="submit"
          className="w-full bg-cyan-600 text-white py-2 rounded hover:bg-cyan-700"
          disabled={loading}
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </button>
      </form>
    </div>
  );
};

export default ForgotPassword;
